import script from "./TableContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./TableContainer.vue?vue&type=script&setup=true&lang=js"

import "./TableContainer.vue?vue&type=style&index=0&id=02d84524&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02d84524"]])

export default __exports__